module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_phone-01dc84d9a75d048bef0cc4289c899f1e.svg";